/* eslint-disable no-console */
<template>

  <div class="main_unit">
    <div class="store_login_unit">{{brandStoreName}}</div>
    <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
    <div v-show="!isInitLoading">
      <div class="wd976 tbl_ht_login_info tbl_bg_blue">
        <form class="form_checkSetting">
          <div class="wd720">
            <Message v-if="validationMessage" :validationMessage="alertMessage" /><br>
            <Message v-if="validationMessage" :validationMessage="validationMessage" />
          </div>
          <div class="lavel_tyori right_comment">
          </div>
          <div class="wd200 mgl_24" id="diesplaySet_id" @change="selectCookingId($event)" >
            <select class="wd200" v-model="selectButton">
              <option value="null" disabled>ボタンを選択</option>
              <option :value="cookingButton.cookingCheckButtonId" v-for="cookingButton in cookingCheckButton" :key="cookingButton.cookingCheckButtonId">
                {{cookingButton.upperButtonName}} {{cookingButton.lowerButtonName}}</option>
            </select>
          </div>

          <div class="lavel_store right_comment" style="vertical-align: middle">
            <label for="releaseSelect">リリース日</label>
          </div>
          <div class="input_store left_comment selectFile mgl_10" id="releaseSelect">
            <select v-model="applyStartDate" class="wd250" @change="init">
              <option v-for="releaseHistory in releaseHistories" :key="releaseHistory" :value="releaseHistory" :id="releaseHistory">
                {{releaseHistory}}</option>
            </select>
          </div>

          <div class="lavel_tyori right_comment">
            <label for="diesplaySetList_id"></label>
          </div>
          <div  class="tbl_bg_blue mgt_15" name="pageSetting" id="diesplaySetList_id" >
            <table class="checkSetting_tbl_unit wd750 tyori_setting_height tyori_setting_table mgl_24">
              <tbody>
              <tr>
                <th class="wd70" rowspan="2" style="text-align: center">表示順</th>
                <th class="wd240" rowspan="2" style="text-align: center">調理名</th>
                <th v-if="isExitsGroup" class="wd240" style="text-align: center">グループ名</th>
                <th class="wd170" rowspan="2" style="text-align: center">機材名</th>
              </tr>
              <tr>
                <th v-if="isExitsGroup" class="border_top_none alertList_text_align">
                  <select id="selectGroup"  v-model="selectGroupWord">
                    <option value="">全て</option>
                    <option v-for="group in groupNameList" :key="group" :value="group">{{group}}</option>
                  </select>
                </th>
              </tr>
              </tbody>
              <tbody>
              <tr v-for="(cookingNameListData, index) in filterItems" :key="index">
                <td class="text_white_space">{{cookingNameListData.cookingNameNo}}</td>
                <td class="text_white_space">{{cookingNameListData.cookingName}}</td>
                <td class="text_white_space" v-if="isExitsGroup" >{{cookingNameListData.groupName}}</td>
                <td>
<!--                  <select multiple class="wd160" v-model="cookingNameListData.fkSensorId" @change="sensorSelect($event, index)">-->
                  <select multiple class="wd160 hg65" v-model="cookingNameListData.fkSensorId">
                    <option v-for="sensor in sensorList" :key="sensor.sensorId" :value="sensor.fkSensorId" :id="sensor.sensorId">
                      {{sensor.location}}:({{sensor.sensorId}})</option>
                  </select>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </form><br>
      </div>
      <div>
        <div class="btn_submit" style="text-align: center">
          <ul class="set_ul_tbl_buttan" style="display: inline-block">
            <li>
              <router-link class="checkSetting_buttan_unit" :to="{ name: 'managemenu'} ">キャンセル</router-link>
            </li>
          </ul>
          <ul class="set_ul_tbl_buttan" style="display: inline-block">
            <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="update">更新</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="overlay_loder" v-show="isLoading">
      <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
    </div>
    <div class="overlay" v-show="showContent">
      <div>
        <div class="modal_box wd570">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit">調理名機器設定 更新確認</p>
            </div>
          </div>
          <div class="modal_content_tex">
            <p>更新しました。</p>
          </div>

          <div class="btn_submit_box">
            <div class="btn_submit">
              <a href="#" @click.prevent.stop="closeModelComp">OK</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import PulseLoader from '@/app/components/PulseLoader.vue'
import Message from '@/app/components/Message.vue'
export default {
  name: 'SensorAssignmentCookingName',
  components: {
    PulseLoader,
    Message
  },
  data: function () {
    return {
      applyStartDate:null,
      releaseHistories:[],
      date:null,
      isLoading:false,
      isInitLoading:true,
      validationMerowspanssage:'',
      alertMessage:'入力エラーがあります。',
      showContent:false,
      // 重要管理項目チェックボタン一覧取得
      cookingCheckButton: null,
      sensorAssignmentCookingNameList: [],
      groupNameList:[],
      selectGroupWord:"",
      sensorList:[],
      isExitsGroup:false,
      selectButton:null,
    }
  },
  computed:{
    brandPath: function () {
        return this.$store.getters['brand/path']
    },
    brandStoreName: function () {
        let brandName = this.$store.getters['brand/name']
        let storeName = this.$store.getters['store/name']

        if (brandName == null) {
          brandName = ''
        }

        if (storeName == null) {
          storeName = ''
        }

        return brandName + '・' + storeName
    },
    filterItems() {
        var data = this.sensorAssignmentCookingNameList;
        // グループフィルター
        if(this.selectGroupWord !== ""){
          var filterGroupWord = this.selectGroupWord && this.selectGroupWord.toLowerCase();
          if(filterGroupWord === '未グループ') {
            data = data.filter(function (row){
              return row["groupName"] == null;
            })
          } else {
            data = data.filter(function (row){
              return Object.keys(row).some(function (){
                return String(row["groupName"]).toLowerCase().indexOf(filterGroupWord) === 0
              })
            })
          }
        }
        return data;
    },
  },
  created: function(){
    this.calc();
  },
  methods:{
    async calc(){

      this.isInitLoading = true;

      //調理名機器設定一覧取得API
      var brandId = this.$store.getters['brand/id'];
      var storeId = this.$store.getters['store/id'];
      var datetime = this.dateFormat();
      var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/cooking_check?datetime=' + datetime;

      await this.$axios
          .get(url,{storeId:storeId})
          .then(response => (this.cookingCheckButton = response.data.cookingCheckButton))
          .catch((err)=> {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }).finally(()=> this.isInitLoading = false);

    },
    validationCheck(sensorAssignmentCookingNameListArray) {

      //最小件数チェック
      if (sensorAssignmentCookingNameListArray.length == 0) {
        this.validationMessage = '調理名は1件以上登録を実施してください。'
        return false;
      }

      let selectedSensorIdList = sensorAssignmentCookingNameListArray.every(e => e.fkSensorId.length === 0)
      if (selectedSensorIdList.length <= 0){
        this.validationMessage = '中心温度計を選択してください。'
        return false;
      }

      //最大件数チェック
      if (sensorAssignmentCookingNameListArray.length>200) {
        this.validationMessage = '調理名は200件まで登録可能です'
        return false;
      }

      for(var k = 0 ; k < sensorAssignmentCookingNameListArray.length ; k++) {
        if(sensorAssignmentCookingNameListArray[k].cookingNameId === '' || sensorAssignmentCookingNameListArray[k].cookingNameId === null || sensorAssignmentCookingNameListArray[k].cookingNameId === undefined ) {
          this.validationMessage = '調理名の値が正しくありません。';
          return false;
        }
        var selectedSensors = sensorAssignmentCookingNameListArray[k].fkSensorId.some( value => this.sensorList.includes(value))
        if(selectedSensors.length <= 0){
          this.validationMessage = '中心温度計の値が正しくありません。';
          return false;
        }
      }
      return true;
    },
    async update(){

      this.isLoading = true;

      //エラー内容初期化
      this.clearError();

      let sensorAssignmentCookingNameListArray = this.sensorAssignmentCookingNameList;

      // バリデーションチェック
      if(!this.validationCheck(sensorAssignmentCookingNameListArray)){
        this.isLoading = false;
        this.scrollTop();
        return null;
      }

      //正常時、API呼び出し
      let ListArrayRequestArray = this.getRequestArray(sensorAssignmentCookingNameListArray);

      // API処理判定
      var apiResponseFlg = true;

      var brandId = this.$store.getters['brand/id'];
      var storeId = this.$store.getters['store/id'];
      var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/sensor_assignment_check_name';

      await this.$axios
          .post(url,{sensorAssignmentCookingNameList:ListArrayRequestArray,apply_start_date: this.applyStartDate})
          .then()
          .catch((err)=> {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            apiResponseFlg = false;
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.validationMessage =  error.message;
                this.scrollTop();
              }
            }
            if(error.code !== 400){
              this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }
          }).finally(()=> this.isLoading = false);

      // API処理判定
      if(apiResponseFlg){
        this.showContent = true;
      }
    },
    getRequestArray(sensorAssignmentCookingNameListArray) {
      var ListArrayRequestArray = new Array();
      // 送信用データ作成
      for(var listArrayCount =0 ; listArrayCount < sensorAssignmentCookingNameListArray.length ; listArrayCount++){
        for (var j = 0; j < sensorAssignmentCookingNameListArray[listArrayCount].fkSensorId.length; j++) {
          var requestObj = new Object();
          requestObj['cooking_name_id'] = sensorAssignmentCookingNameListArray[listArrayCount].cookingNameId;
          requestObj['sensor_id'] = sensorAssignmentCookingNameListArray[listArrayCount].fkSensorId[j];
          ListArrayRequestArray.push(requestObj)
        }
      }
      return ListArrayRequestArray;
    },
    async selectCookingId(event){

      this.isLoading = true;
      var brandId = this.$store.getters['brand/id'];
      var storeId = this.$store.getters['store/id'];
      var apiResponseFlg = true;
      if(event !== null){
        this.selectButtonId = event.target.value;
        this.cookingCheckButtonId = event.target.value;
        // ボタン選択が変更された場合、リリース日、入力を初期化する。
        this.date = null;
        this.applyStartDate = null;
        // datepikerの日付を成形(翌日日付け)
        this.vDatePickerMinDay = this.checkDateBusinessDay();
      }

      // 種別の選択確認
      this.validationMessage = "";

      var applyStartDate = "";
      // 取得する日付を指定

      if(this.applyStartDate !== null){
        applyStartDate = this.applyStartDate;
      }

      // 調理名機器設定一覧取得API
      var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/sensor_assignment_check_name/' + this.cookingCheckButtonId;

      await this.$axios
          .get(url,{ params: {apply_start_date:applyStartDate}})
          .then(response => {
            this.sensorAssignmentCookingNameList = response.data.sensorAssignmentCookingNameList;
            for (var o = 0; o < this.sensorAssignmentCookingNameList.length; o++) {
              this.sensorAssignmentCookingNameList[o].fkSensorId = new Array();
              this.sensorAssignmentCookingNameList[o].sensorId = new Array();
              this.sensorAssignmentCookingNameList[o].location = new Array();
              for(var g = 0; g < this.sensorAssignmentCookingNameList[o].sensorSetting.length; g++) {
                this.sensorAssignmentCookingNameList[o].fkSensorId.push(this.sensorAssignmentCookingNameList[o].sensorSetting[g].id);
                this.sensorAssignmentCookingNameList[o].sensorId.push(this.sensorAssignmentCookingNameList[o].sensorSetting[g].sensorId);
                this.sensorAssignmentCookingNameList[o].location.push(this.sensorAssignmentCookingNameList[o].sensorSetting[g].location);
              }
            }
            this.releaseHistories = response.data.releaseHistories,
            this.applyStartDate = response.data.applyStartDate,
            this.groupNameList = [...new Set(this.sensorAssignmentCookingNameList.map(item => item.groupName).filter(group => group))]
            this.sensorList = response.data.sensorList;
            this.isExitsGroup = this.groupNameList.length > 0;
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }).finally(()=> this.isLoading = false);

      // API処理判定
      if(!apiResponseFlg){
        return null;
      }
    },
    clearError:function(){
      //メッセージ初期化
      this.validationMessage = "";
    },
    closeModel() {
      this.showContent = false;
    },
    scrollTop() {
      window.scrollTo(0,0);
    },
    closeModelComp(){
      this.showContent = false;
      // 初期化処理
      this.selectCookingId(null);
      // パラメータ初期化
      this.date = null;
      this.scrollTop();
    },
    init(){
      // 画面の初期化
      this.selectCookingId(null);
    },
    checkDateBusinessDay(){
      let minAllowedDay = new Date();
      let hours = ("0" + minAllowedDay.getHours()).slice(-2);

      // AM00-AM03時の判定
      if(hours >= '03' && hours <= '23'){
        minAllowedDay.setDate(minAllowedDay.getDate() +1);
      }
      return new Date(minAllowedDay.getFullYear(),minAllowedDay.getMonth(),minAllowedDay.getDate());
    },
    sensorSelect:function (event,indexCOunt) {

      var textValue = event.target.value;
      var item = this.sensorAssignmentCookingNameList[indexCOunt];
      item['fkSensorId'] = textValue;

      //配列に反映
      this.sensorAssignmentCookingNameList.splice(indexCOunt,1,item);

    },
    dateFormat(){
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
      let day = ("0" + nowDate.getDate()).slice(-2);
      let hours = ("0" + nowDate.getHours()).slice(-2);
      let minutes = ("0" + nowDate.getMinutes()).slice(-2);
      let seconds = ("0" + nowDate.getSeconds()).slice(-2);

      let format_str = 'YYYYMMDDhhmmss'
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);
      format_str = format_str.replace(/hh/g,hours);
      format_str = format_str.replace(/mm/g,minutes);
      format_str = format_str.replace(/ss/g,seconds);
      return format_str;
    },
  }
}
</script>